function generalJS() {
  const banner = document.querySelector(".bannerSmart");
  if (banner) {
    const content = banner.innerHTML;
    banner.innerHTML = `<div class="marquee-content">${content}${content}</div>`;
  }
}


function customizeSelect() {
  const customSelect = document.getElementById("orderFilter");
  if (!customSelect) {
    return;
  }

  const trigger = customSelect.querySelector(".custom-select-trigger");
  const options = customSelect.querySelectorAll(".custom-option");

  if (!trigger || !options.length) {
    return;
  }

  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    customSelect.classList.toggle("open");
  });

  options.forEach((option, index) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const orderValue = option.dataset.value;

      trigger.textContent = option.textContent;
      customSelect.classList.remove("open");
      customSelect.dataset.value = orderValue;

      const changeEvent = new CustomEvent("orderChanged", {
        detail: orderValue,
      });

      customSelect.dispatchEvent(changeEvent);
    });
  });

  document.addEventListener("click", (e) => {
    if (!customSelect.contains(e.target)) {
      customSelect.classList.remove("open");
    }
  });
}

export { generalJS, customizeSelect };
